import React, { FC } from 'react';
import { FormCheckboxToggleStyled } from './toggle.styled';

export const FormCheckboxToggle: FC = () => {
  return <FormCheckboxToggleStyled />;
};

FormCheckboxToggle.displayName = 'FormCheckboxToggle';
